import { useTranslation } from 'react-i18next';
import { Modal, Transfer, Flex, Typography, Tag } from 'antd';
import { IconArrowsExchange } from '@tabler/icons-react';
import type { AssociationTransferModalViewProps } from './AssociationTransferModal.types';
import { transferStyles, modalConfig } from './AssociationTransferModal.styles';

const { Text } = Typography;

export const AssociationTransferModal = ({
  open,
  sourceConfigName,
  sourceCode,
  sourceName,
  counterpartLabel,
  dataSource,
  targetKeys,
  onOk,
  onClose,
  onTransferChange,
  filterOption,
}: AssociationTransferModalViewProps) => {
  const { t } = useTranslation('componentSchema');

  return (
    <Modal
      title={
        <Flex align="flex-start" gap={10} style={{ paddingInlineEnd: 24 }}>
          <IconArrowsExchange
            size={20}
            color="#1E6DF6"
            style={{ flexShrink: 0, marginTop: 2 }}
          />
          <Text strong style={transferStyles.title}>
            {t('associations.manageFor', {
              type: counterpartLabel,
              name: sourceName,
              code: sourceCode,
            })}
          </Text>
        </Flex>
      }
      open={open}
      onOk={onOk}
      onCancel={onClose}
      width={modalConfig.width}
      styles={modalConfig.styles}
      okText={t('associations.save')}
      cancelText={t('associations.cancel')}
      destroyOnHidden
      centered
    >
      <Flex vertical gap={12} style={transferStyles.container}>
        <Flex align="center" gap={8} wrap="wrap">
          <Tag color="blue" style={{ maxWidth: '100%', whiteSpace: 'normal' }}>
            {sourceConfigName}: {sourceCode}
          </Tag>
        </Flex>

        <Transfer
          dataSource={dataSource}
          titles={[t('associations.available'), t('associations.assigned')]}
          targetKeys={targetKeys}
          onChange={onTransferChange}
          render={(item) => (
            <span
              style={{
                display: 'inline-block',
                maxWidth: '100%',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                verticalAlign: 'bottom',
              }}
              title={item.title}
            >
              {item.title}
            </span>
          )}
          showSearch
          filterOption={filterOption}
          style={transferStyles.transfer}
          styles={{
            section: transferStyles.section,
          }}
          locale={{
            searchPlaceholder: t('associations.searchPlaceholder'),
          }}
        />
      </Flex>
    </Modal>
  );
};
